import { CommunityFeedFilters, CommunityMemberType } from 'generated/graphql';

export type FeedAuthorFilter = 'all' | 'mine';

// community-service rejects a search of fewer than 3 characters, so a shorter
// term is treated as no text filter at all.
export const MIN_SEARCH_LENGTH = 3;

export const toCommunityFeedFilters = (
  filter: FeedAuthorFilter,
  ownerId: number | null,
  search = '',
): CommunityFeedFilters | undefined => {
  const trimmedSearch = search.trim();

  const authorFilter: CommunityFeedFilters =
    filter === 'mine' && ownerId !== null
      ? {
          authors: [
            { memberType: CommunityMemberType.Creator, memberId: ownerId },
          ],
        }
      : {};
  const searchFilter: CommunityFeedFilters =
    trimmedSearch.length >= MIN_SEARCH_LENGTH ? { search: trimmedSearch } : {};

  const filters: CommunityFeedFilters = { ...authorFilter, ...searchFilter };
  return filters.authors || filters.search ? filters : undefined;
};
